<template>
    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="login-form">
        <el-form-item prop="tel">
            <el-input v-model.trim="loginForm.tel" placeholder="请输入手机号" maxlength="11" ref="tel"
                clearable autocomplete="on">
            </el-input>
        </el-form-item>
        <el-form-item prop="code">
            <el-input type="txt" class="padding-right" placeholder="请输入验证码" maxlength="6"
                v-model.trim="loginForm.code" clearable autocomplete="off">
            </el-input>
            <el-button v-show="codeSta" 
                :class="{'get-code-btn': true, 'disabled': !loginForm.tel || !/^1[3456789]\d{9}$/.test(loginForm.tel)}"
                @click="getCode()">获取验证码</el-button>
            <el-button v-show="!codeSta" class="get-code-btn">{{ count }}s</el-button>
        </el-form-item>
        <el-form-item prop="pwd">
            <el-input type="password" placeholder="密码(8-20位大小字母、数字、符号组合)" v-model="loginForm.pwd" 
                clearable show-password>
            </el-input>
        </el-form-item>
        <div class="agree-deal" v-if="delegateList && delegateList.length > 0">
            <el-checkbox v-model="ischecked"></el-checkbox>
            <span>我已阅读并同意</span><template v-for="(item, index) in delegateList">
                <span :key="index" v-if="index > 0">和</span>
                <em :key="'key' + index" @click="openUrl(item.url)">《{{item.name}}》</em>
            </template>
        </div>
        <div class="login-btn">
            <el-button type="primary" @click="submitForm('loginForm')" :disabled="
                !loginForm.tel ||
                !loginForm.code ||
                !loginForm.pwd ||
                !ischecked
            ">立即注册
            </el-button>
        </div>
    </el-form>
</template>

<script>
import loginApi from '@/resources/loginModule/login'

export default {
    data: function () {
        // 验证密码
        let checkPwd = (rule, value, callback) => {
            let reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-z]|[A-Z]|[0-9]){8,20}$/;
            if (!value) {
                return callback(new Error('请输入密码'));
            } else if (!reg.test(value)) {
                return callback(new Error('8-20位大小字母、数字、符号组合'));
            } else {
                callback();
            }
        };
        // 验证手机号
        let checkTel = (rule, value, callback) => {
            let reg = /^1[3456789]\d{9}$/;
            if (!value) {
                return callback(new Error('请输入手机号'));
            } else if (!reg.test(value)) {
                return callback(new Error('请输入正确的手机号'));
            } else {
                callback();
            }
        };
        return {
            codeSta: true, //获取验证码按钮状态
            count: '',
            timer: null,
            //表单数据
            loginForm: {
                userName: '',
                pwd: '',
                tel: '',
                code: '',
            },
            //校验
            rules: {
                pwd: [{ required: true, validator: checkPwd, trigger: 'blur' }],
                tel: [{ required: true, validator: checkTel, trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
            },
            ischecked: true,
            dialogVisible: false,
            originUrl: '',
            delegateList: [], // 协议、隐私
        };
    },
    created() {
        if (sessionStorage.delegateList) {
            this.delegateList = JSON.parse(sessionStorage.delegateList);
        }
    },
    methods: {
        // 获取验证码
        getCode() {
            if (!/^1[3456789]\d{9}$/.test(this.loginForm.tel)) {
                return false;
            }
            this.sendMobileCode();
        },
        // 验证码倒计时
        codeCountdown() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.codeSta = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.codeSta = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        // 手机号注册
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let para = {
                        mobile: this.loginForm.tel,
                        password: this.loginForm.pwd,
                        captcha: this.loginForm.code,
                    };
                    let headers = {
                        tenantCode: '880p33' // GTA管理组
                    }
                    if (/fjcz\.gtafe\.com/i.test(sessionStorage.originUrl)) {
                        headers.tenantCode = 'PVCFQ'; // 福建船政
                    }
                    loginApi.mobileRegister(para, headers).then((res) => {
                        if (res.returnCode === 200) {
                            this.$router.push({ path: '/app/login' });
                            console.log('this.registerForm:', this.loginForm);
                            // 进行跨域通信
                            let data = res.data;
                            this.sendMessageToParent(data);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        // 跨域通信方法
        sendMessageToParent(data) {
            let originPort = sessionStorage.originPort;
            let originUrl = sessionStorage.originUrl;
            let originUrl2 = 'http://localhost:' + originPort;
            if (originUrl) {
                parent.postMessage(data, originUrl);
            } else {
                parent.postMessage(data, originUrl2);
            }
        },
        //发送验证码
        sendMobileCode() {
            let that = this;
            let para = {
                mobile: that.loginForm.tel,
                operationFlag: 1, //1.注册 2.忘记密码 3.登录 4.绑定手机号
            };
            loginApi.sendMobileCode(para).then((res) => {
                if (res.returnCode === 200) {
                    that.codeCountdown();
                } else if (res.returnCode === 40016) {
                    // that.dialogVisible = true
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        openUrl(url) {
            window.open(url);
        }
    },
}
</script>

<style scoped>
@import "~@/assets/css/login/login.css";
</style>